import type { Component } from "vue"
import { defineAsyncComponent } from "vue"
import { sharedBlockRegistry } from "../blocks/registry"

// `main-cart` block type → renderer. Lazy, like the section and PDP registries:
// a drawer only pays for the blocks the seller actually placed.
export const cartBlockRegistry: Record<string, Component> = {
  // The shared library first, so a host-specific entry of the same type
  // still wins rather than being shadowed at a distance.
  ...sharedBlockRegistry,
  "line-items": defineAsyncComponent(() => import("./CartLineItems.vue")),
  subtotal: defineAsyncComponent(() => import("./CartSubtotal.vue")),
  "checkout-button": defineAsyncComponent(() => import("./CartCheckoutButton.vue")),
  countdown: defineAsyncComponent(() => import("./CartCountdown.vue")),
  "progress-bar": defineAsyncComponent(() => import("./CartProgressBar.vue")),
  note: defineAsyncComponent(() => import("./CartNote.vue")),
  discount: defineAsyncComponent(() => import("./CartDiscount.vue")),
  savings: defineAsyncComponent(() => import("./CartSavings.vue")),
  "trust-badges": defineAsyncComponent(() => import("./CartTrustBadges.vue")),
  "product-upsell": defineAsyncComponent(() => import("./CartProductUpsell.vue")),
  "payment-icons": defineAsyncComponent(() => import("./CartPaymentIcons.vue")),
  "checkpoint-bar": defineAsyncComponent(() => import("./CartCheckpointBar.vue")),
  "policies-checkbox": defineAsyncComponent(() => import("./CartPoliciesCheckbox.vue")),
  "text-with-icon": defineAsyncComponent(() => import("./CartTextWithIcon.vue")),
  "icon-row": defineAsyncComponent(() => import("./CartIconRow.vue")),
  image: defineAsyncComponent(() => import("./CartImage.vue")),
  "custom-html": defineAsyncComponent(() => import("./CartCustomHtml.vue")),
}

export function hasCartBlock(type: string): boolean {
  return type in cartBlockRegistry
}
